import script from "./EducationHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationHistory.vue?vue&type=script&setup=true&lang=js"

import "./EducationHistory.vue?vue&type=style&index=0&id=19471f6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19471f6a"]])

export default __exports__